import React from 'react';

export default function PageBanner() {
  return (
    <div className="hidden lg:block w-full h-48 relative mb-6">
      <img
        src="/assets/banner02.jpg"
        alt="ARAC Banner"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/30" />
    </div>
  );
}